import Vue from "vue/dist/vue.esm.js";
import VCalendar from "v-calendar";
import axios from "axios";
import VueAxios from "vue-axios";
import Simplemodal from "../../plugins/simplemodal.js";
import { isInteger, isNumber } from "lodash";
var moment = require("moment");
Vue.use(VCalendar, axios, VueAxios);

//現在の時刻の切り分け
var date = new Date();
date.setMinutes(Math.round(date.getMinutes() / 30) * 30);

const time = ("00" + date.getHours()).slice(-2);
const minutes = ("00" + date.getMinutes()).slice(-2);
const rangemodal = new Simplemodal({
  trigger: "data-rangemodal-trigger",
  clickOutSideClose: true,
  backFixed: true,
});

if (document.querySelector("#rangecalendar")) {
  const eventDate = document
    .querySelector("#rangecalendar")
    .dataset.start.split("-");

  new Vue({
    el: "#rangecalendar",
    data() {
      return {
        dates: [],
        map_dates:[],
        selected: {
          date: {
            start: null,
            end: null,
          },
        },
        minDate: null,
        maxDate: null,
        couter: null,
        compareDates: [],
        bundleDate: "",
        bundleTimeStart: "",
        bundleTimeEnd:"",
        bundleflag: true,
        errors: "",
      };
    },
    mounted() {
      const self = this;
      const eventId = this.$el.dataset.event_id;

      self.minDate = this.$el.dataset.start;
      self.maxDate = this.$el.dataset.end;

      axios
        .get(`/mypage/events/${eventId}/event_schedules`)
        .then(function (response) {
          if (response.data.data && response.data.data.length > 0) {
            self.dates = self.dates.concat(response.data.data);
          } else {
            self.dates.push({
              date: {
                start: `${eventDate[0]}/${eventDate[1]}/${eventDate[2]} ${time}:${minutes}`,
                end: `${eventDate[0]}/${eventDate[1]}/${eventDate[2]} ${time}:${minutes}`,
              },
            });
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    filters: {
      moment_date: function (date) {
        return moment(date).format("YYYY/MM/DD HH:mm");
      },
    },
    methods: {
      addDate() {
        this.dates.push({
          date: {
            start: `${eventDate[0]}/${eventDate[1]}/${eventDate[2]} ${time}:${minutes}`,
            end: `${eventDate[0]}/${eventDate[1]}/${eventDate[2]} ${time}:${minutes}`,
          },
        });
      },
      removeDate(date, hide) {
        this.dates = this.dates.filter((d) => d !== date);
        this.map_dates = this.map_dates.filter((d) => d !== date);
        hide();
      },
      dateSelected(e, date, toggle) {
        this.selected = date;
        toggle({ ref: e.target });
      },
      onDayClick: function (index) {
        this.dates[index].date.end = moment(this.selected.date.start).format(
          "YYYY/MM/DD HH:mm"
        );
        // this.minDate = day.id;
        // this.maxDate = day.id;
      },
      handleSubmit: function () {
        const self = this;
        const eventId = this.$el.dataset.event_id;
        const csrfToken = document.head.querySelector(
          "[name=csrf-token][content]"
        ).content;
        const params = { event_schedules: this.bundleDates };

        this.errors = "";

        axios
          .post(`/mypage/events/${eventId}/update_schedule`, params, {
            headers: { "X-CSRF-Token": csrfToken },
          })
          .then(function (response) {
            console.log("ok");
            if (response.data.status == "ok") {
              rangemodal.show("js-modal-success", {});
            }

            if (response.data.status == "error") {
              self.errors = response.data.messages;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      },
      bundleCompare(startDate, endDate) {
        const dateDiff = endDate.diff(startDate.subtract(1, "days"), "days");
        return dateDiff;
      },
      getBundleDate: function () {
        let startDate = moment(this.minDate);
        const endDate = moment(this.maxDate);
        const dateDiff = this.
        bundleCompare(startDate, endDate);
        for (let stDate = 0; stDate < dateDiff; stDate++) {
          this.compareDates.push(startDate.add(1, "days").format("YYYY/MM/DD"));
        }
      },
      addBundleDateClick: function () {
        new Simplemodal({
          trigger: "data-bundleDate-trigger",
          clickOutSideClose: true,
          backFixed: true,
        });
        this.getBundleDate();
      },
      // createBundleDates: function (dateDiff) {
      //   for (let stDate = 0; stDate < dateDiff; stDate++) {
      //     this.bundleDates.push(startDate.add(1, "days").format("YYYY/MM/DD"));
      //   }
      // },

      bundleSubmit() {
        // const ret = this.bundleCompare();
        // if(ret > 0) {
        //   this.bundleflag = true;
        // } else {
        //   this.bundleflag = false;
        // }


        let _d = new Date(this.bundleDate);
        const _30min = 60 * 30 * 1000;
        let start = Number(this.bundleTimeStart);
        let end = Number(this.bundleTimeEnd);

        const d = new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), 0, 0, 0).getTime();
        const diff = end - start;
      
        const map_dates = new Map();

        this.map_dates.forEach(d => map_dates.set(new Date(d.date.start).getTime(), d))

        const dates = new Array(diff).fill().map((_, index) => {
          return {
            date:{
              start:new Date(d + (_30min * (index + start) )).toLocaleString().slice(0, -3),
              end:new Date(d + (_30min * (index + start + 1))).toLocaleString().slice(0, -3)
            }
          }
        })
        .forEach(d => map_dates.set(new Date(d.date.start).getTime(), d))

        this.map_dates = Array.from(map_dates).map(d => d[1]);
        // this.dates = [...this.dates, ...dates];

        

        
      },
    },
    watch: {
      bundleStart(newVal, oldVal) {
        let startDate = moment(newVal);
        let endDate = moment(this.bundleEnd || startDate);
        const dateDiff = this.bundleCompare(startDate, endDate);
        const count = dateDiff * 1440 / 30;
        const _1day = 60 * 60 * 24 * 1000;
        const _30min = 60 * 30 * 1000;
        const correction = 0;
        const limitDate = new Date(this.compareDates.slice(-1)).getTime() + _1day - (_30min * correction);

        const arr_diff = new Array(dateDiff).fill().map((d, index) => new Date(startDate).getTime() + ((index + 1) * _1day))
        const temp  = arr_diff.map(date => {
          return new Array(49)
          .fill()
          .map((_, index) => new Date(date).getTime() + (index * _30min))
        })
        .flat()

        const filltedDate = (dates) => {
          const index = dates.indexOf(limitDate);
          let pos_e = 0;
          if(index != -1) {
            pos_e = dates.length - index;
          }
          const start = dates.slice(0, -1 - pos_e).map(d => new Date(d));
          const end = dates.slice(1, dates.length - pos_e).map(d => new Date(d));
          const concat = start
          .map((d, index) => ({start:d, end:end[index]}))
          .map(date => ({
            date:{
              start:date.start.toLocaleString().slice(0, -3),
              end:date.end.toLocaleString().slice(0, -3),
            }

          }));

          console.log(concat)
          return concat;
        };
     
        return filltedDate(temp); 
      },
    },
    created() {
      var self = this;
      self.$nextTick(function () {
        self.addBundleDateClick();
      });
    },
    computed: {
      bundleSubmitFlg() {
        let date = this.bundleDate;
        let start = this.bundleTimeStart;
        let end = this.bundleTimeEnd;
        let seFlg = start && end && ((end - start) > 0);

        if(date && seFlg) {
          return false;
        }
        else {
          return true;
        }
      },

      bundleDates() {
        return [...this.map_dates, ...this.dates];
      }


    }
  });
}
